module.exports = __webpack_public_path__ + "img/downloaded-products.ff79c53d.svg";